import CounterControls from "./counter";
import { useTranslation } from "react-i18next";
import { useBookInfContext } from "components/context/bookInfContext";
import FeadToggle from "components/button/feadToggle/feadToggle";
import Tooltip from "components/tooltip";

export default function RoomInfMb() {
  const { t } = useTranslation();
  const { bookInf, onBookInf } = useBookInfContext();

  const desc =
    bookInf?.frmCnt > 1 || bookInf?.adltCnt > 1 ? (
      <div className="center mt-[-10px] mb-[20px] font-font-B">
        <h5>
          {t("bck_ttl_hm_rm_cnt")} {bookInf?.rmCnt}
          <span>/</span>
        </h5>
        <h5>
          <span>
            {t("txt_adlt_bk")} {bookInf?.adltCnt}
          </span>
          <span className="px-2">
            {t("txt_chld_bk")} {bookInf?.childCnt ?? 0}
          </span>
        </h5>
      </div>
    ) : undefined;

  return (
    <>
      <FeadToggle
        text={
          bookInf?.rmCnt && bookInf?.adltCnt
            ? t("bck_ttl_hm_in_inf")
            : t("bck_ttl_hm_ldg_inf_slt")
        }
        styles="room-inf-mb"
        btnStyles="btn-toggle"
        desc={desc}
        maxHeight={220}
      >
        <ul className="flex flex-col gap-[16px] px-[1rem] pb-[1rem]">
          <li>
            <h5>{t("bck_ttl_hm_rm_cnt")}</h5>
            <CounterControls
              count={bookInf?.rmCnt}
              handleDecrease={() => {
                if (bookInf?.rmCnt === 1) {
                  return;
                }
                onBookInf({
                  rmCnt: bookInf?.rmCnt - 1,
                });
              }}
              handleIncrease={() => {
                onBookInf({
                  rmCnt: bookInf?.rmCnt + 1,
                });
              }}
            />
          </li>
          <li>
            <h5>{t("bck_ttl_hm_adl")}</h5>
            <CounterControls
              count={bookInf?.adltCnt}
              handleDecrease={() => {
                if (bookInf?.adltCnt === 1) {
                  return;
                }
                onBookInf({
                  adltCnt: bookInf?.adltCnt - 1,
                });
              }}
              handleIncrease={() => {
                onBookInf({
                  adltCnt: bookInf?.adltCnt + 1,
                });
              }}
            />
          </li>
          <li>
            <h5 className="">
              <span>{t("bck_ttl_hm_chl")}</span>
            </h5>

            <CounterControls
              count={bookInf?.childCnt}
              disabled={bookInf?.childCnt === 0}
              handleDecrease={() => {
                if (bookInf?.childCnt === 0) {
                  return;
                }
                onBookInf({
                  childCnt: bookInf?.childCnt - 1,
                });
              }}
              handleIncrease={() => {
                onBookInf({
                  childCnt: bookInf?.childCnt + 1,
                });
              }}
            />
          </li>
        </ul>
      </FeadToggle>
    </>
  );
}
